// 遊戲 def 型別查表（後端權威 slotdef.proto，package Slot001FaFaCat）。
import type * as protobuf from 'protobufjs'
import { lookupType } from './protoRoot'

export function slotResultType(): protobuf.Type {
  return lookupType('Slot001FaFaCat.SlotResult')
}

export function spinCmdType(): protobuf.Type {
  return lookupType('Slot001FaFaCat.SpinCmd')
}

/** google.protobuf.Any — spin 回應的 ResponseInfo.Data 外層包裝。 */
export function anyType(): protobuf.Type {
  return lookupType('google.protobuf.Any')
}
